import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=3ff07a1a"
import script from "./DateField.vue?vue&type=script&setup=true&lang=js"
export * from "./DateField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff07a1a')) {
      api.createRecord('3ff07a1a', component.options)
    } else {
      api.reload('3ff07a1a', component.options)
    }
    module.hot.accept("./DateField.vue?vue&type=template&id=3ff07a1a", function () {
      api.rerender('3ff07a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/calendars/DateField.vue"
export default component.exports